import "animate.css";
import { Col, Container, Row, Tab } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import colorSharp2 from "../assets/img/color-sharp2.png";
import { ProjectCard } from "./ProjectCard";

export const Projects = () => {
  const projects = [
    {
      title: "Acting Fible",
      description: "Design & Development",
      imgUrl: "https://i.ibb.co/XZ46xvX/1.png",
      githubLink: "https://github.com/rahim-uddin-jsr/acting-fable-client",
      liveLink: "https://acting-fible.firebaseapp.com/",
      serverLink: "https://github.com/rahim-uddin-jsr/acting-fible-server",
    },
    {
      title: "Kiddo Zone",
      description: "Design & Development",
      imgUrl: "https://i.ibb.co/fd0sFPS/2.png",
      githubLink:
        "https://github.com/rahim-uddin-jsr/toy-marketplace-client-side",
      liveLink: "https://kiddo-zone-b9a3f.web.app/",
      serverLink:
        "https://github.com/rahim-uddin-jsr/toy-marketplace-server-side",
    },
    {
      title: "Foodie Crush",
      description: "Design & Development",
      imgUrl: "https://i.ibb.co/nCgXgMX/3.png",
      githubLink:
        "https://github.com/rahim-uddin-jsr/chef-recipe-hunter-client",
      liveLink: "https://foodie-crush.web.app/",
      serverLink:
        "https://github.com/rahim-uddin-jsr/chef-recipe-hunter-server",
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    I have extensive experience in developing projects using
                    HTML, CSS, JavaScript, ReactJS, Express.js, Node.js,
                    MongoDB, and jQuery. My projects encompass a wide range of
                    web development applications, including responsive website
                    design, interactive user interfaces, dynamic data retrieval,
                    and efficient server-side functionality. With a solid
                    foundation in these technologies, I can deliver high-quality
                    projects that meet the needs of various clients and
                    industries.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    {/* <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Tab 1</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Tab 2</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tab 3</Nav.Link>
                      </Nav.Item>
                    </Nav> */}
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible
                          ? "animate__animated animate__slideInUp pt-5"
                          : "pt-5"
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="section">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
};
